import { createContext } from "react";

/**
 * Where a ReportPanel renders on the Reporting canvas page. In the rail it
 * stays folded to one compact line of figures, and its header opens it. In
 * a tile it stays open, as tall as its content up to the tile, and its body
 * scrolls inside past that; `onClose` adds a Close action to its header. In
 * the phone's list an open panel ("inline") is as tall as its content, and
 * its header folds it. Without a slot, a panel folds and opens in place.
 */
export type ReportSlot =
  | { kind: "rail"; onOpen: () => void }
  | { kind: "tile"; onClose?: () => void }
  | { kind: "inline"; onFold: () => void };

export const ReportSlotContext = createContext<ReportSlot | null>(null);

/** In a rail item whose header carries the headline figure's label, so the
 *  item reads "Website  Sessions" over "2,315 +5%": the headline ReportStat
 *  leaves its own label out. */
export const RailHeadlineContext = createContext(false);
